import * as React from 'react';

export function stringToParagraphs(value = '', render) {
  return (value || '').split('\n').map(render);
}

export function stringToOrderedList(value = '', render) {
  return (value || '').split('\n').map(render);
}
